import React from 'react';
// import styled from 'styled-components';
import { ListView } from '../../list_view/listView';
import { Wrapper, canShowTruckPayoutSplit } from './weeklyPerformanceSection';
import { extractStateStr } from  '../../../../main_board_components/unassignedLoadsTable';
import { loadStatusFormatter, loadStatusColorGenerator } from '../../../../pages/loads/loadDataDelegate'
import {
    dollarAmountsDiffer,
    explicitPayoutAmountByLoadId,
} from '../../../../main_board_components/plannerBoardSettings';

export const LatestLoadsSection = ({
    loadsList,
    payoutLoads,
    truckType,
    driver1,
    driver2,
    canSeeRates = true,
}) => {
    if(!loadsList || loadsList.length === 0)return <Wrapper><div className="NoData"><span>NO LOADS</span></div></Wrapper>;

    const showPayoutSplit = canShowTruckPayoutSplit(canSeeRates, truckType, driver1, driver2);
    const payoutById = showPayoutSplit ? explicitPayoutAmountByLoadId(payoutLoads) : new Map();
    
    const customLoadListingConf = {
        columnProportions: canSeeRates ? "1.2fr 1fr 0.8fr 1fr" : "1.2fr 1fr 1fr",
        columns: [
            {
                label: "Load",
                columnName: "loadNumber",
                clickable: true,
                identifierColumnName: "id",
                path: '/loads/',
            },
            {
                label: "States",
                columnName: "startCityState",
                valueGenerator: (data)=>{
                    let fromToStates = "";
                    try {
                        fromToStates += extractStateStr(data.startCityState);
                        fromToStates += " - " + extractStateStr(data.endCityState)
                    } catch (error) {
                        
                    }
                    return fromToStates;
                },
            },
            ...(canSeeRates ? [{
                label: "Rate",
                columnName: "amountForInvoice",
                valueGenerator: (data)=>{
                    const invoice = data["amountForInvoice"];
                    const tonu = data.loadStatus === "Cancelled" ? " (TONU)" : "";
                    const loadId = data?.id != null ? Number(data.id) : null;
                    const payout = loadId != null && payoutById.has(loadId) ? payoutById.get(loadId) : null;
                    if (
                        payout != null &&
                        invoice != null &&
                        invoice !== '' &&
                        dollarAmountsDiffer(invoice, payout)
                    ) {
                        return `$${invoice}/$${payout}${tonu}`;
                    }
                    return `$${invoice}${tonu}`;
                },
            }] : []),
            {
                label: "Status",
                columnName: "loadStatus",
                alignment: "right",
                conditionalFormatting: (value)=>{
                    let color = loadStatusColorGenerator(value);
                    return `& > * {color:${color}; font-weight:bold;}`
    
                },
                valueInterpreter: (value)=>{
                    return loadStatusFormatter(value);
                },
            }
        ]
    }
    return <ListView 
        ListConf={customLoadListingConf}
        Data={loadsList}
        Error={null}
        NoFooter={true}
    />    
}
